import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';
import { deDasherize } from '@zoocasa/node-kit/strings/de-dasherize';

/**
 * Sanitizes a name by capitalizing words and removing dashes
 */
export function sanitizeName(name = ''): string {
  if (name?.length > 0) {
    return capitalizeWords(deDasherize(name));
  }
  return '';
}

/**
 * Sanitizes a province or state code by converting to uppercase
 */
export function sanitizeProvinceOrStateCode(provinceOrStateCode = ''): string {
  if (provinceOrStateCode?.length > 0) {
    return provinceOrStateCode.toUpperCase();
  }
  return '';
} 